/*
 *	@created: 14.01.2016, 12:07:25
 * 	@author: André Müller <am@ccdm.de>
 *
 */

(function( $ ) {
	var iWindowWidth = $(window).width();
	var iWindowHeight = $(window).height();

	$(window).resize(function(){
		iWindowWidth = $(window).width();
		iWindowHeight = $(window).height();
	});

	$(document).ready(function(){
		// js is enabled
		$('body').removeClass('t3z-nojs');

		/* Button toTop: scroll to the top of the page  */
		$('#totop, .t3z-ce-totop a').click(function(event){
			event.preventDefault();
			var sTarget = 'body';
			scroll2(sTarget, 0);
		});


		/* Menu offcanvas */
		// mobil navigation: add arrows for submenus
		$( "#t3z-mainmenu ul li.sub" ).append( "<span class='mobile-only'></span>" );

		// mobil navigation: open sub level
		$('#t3z-mainmenu ul li.sub > span').click(function(event){
			$(this).parent().toggleClass( "open" );
			$(this).parent().find( "> ul" ).slideToggle( "slow");
		});

		$('#t3z-main-menu-toogle-close').click(function(event){
			$('#t3z-mainmenu ul').find( "li.open > ul" ).slideToggle( "slow");
			$('#t3z-mainmenu ul li.open').removeClass( "open" );

		});



		function scroll2(oElement, iOffset) {
			$('html, body').animate({ scrollTop: ($(oElement).offset().top) + iOffset}, 'slow');
		};

	});

})( jQuery );


//////////////////
// WEBPACK FOOTER
// /Users/wobble/Sites/ksg/www/typo3conf/ext/t3zeroseven/Resources/Public/Sites/Zero/Scripts/Functions.js
// module id = 6N6B
// module chunks = 1